import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

const LevelUpPopup = ({ level, onClose }) => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        setVisible(true);
        const timer = setTimeout(() => {
            setVisible(false);
            setTimeout(onClose, 300);
        }, 3000);
        return () => clearTimeout(timer);
    }, [onClose]);

    return createPortal(
        <div className={`fixed inset-0 z-[9999] flex items-center justify-center transition-opacity duration-300 ${visible ? 'opacity-100' : 'opacity-0'}`}>
            <div className="absolute inset-0 bg-black/50" onClick={onClose} />
            <div className="relative bg-gradient-to-br from-amber-400 to-orange-500 rounded-2xl p-6 text-center shadow-2xl transform scale-100 animate-bounce-in">
                <div className="text-5xl mb-2">☀️</div>
                <div className="text-white text-xl font-bold mb-1">Новый уровень!</div>
                <div className="text-white/90 text-3xl font-black">{level}</div>
            </div>
        </div>,
        document.body
    );
};

export default LevelUpPopup;
